<template>
  <div class="card mt-5 dash">
    <div class="card-header d-flex justify-content-between">
      <div class="card-title">
        {{ $t("message.menu.ca_history") }}
      </div>
      <router-link
        :to="{ name: 'comply-advantage-history' }"
        class="text-button"
      >
        {{ $t("message.menu.all_records") }}
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.52827 3.52876C5.78862 3.26841 6.21073 3.26841 6.47108 3.52876L10.4711 7.52876C10.7314 7.78911 10.7314 8.21122 10.4711 8.47157L6.47108 12.4716C6.21073 12.7319 5.78862 12.7319 5.52827 12.4716C5.26792 12.2112 5.26792 11.7891 5.52827 11.5288L9.05687 8.00016L5.52827 4.47157C5.26792 4.21122 5.26792 3.78911 5.52827 3.52876Z"
            fill="#47B2E4"
          />
        </svg>
      </router-link>
    </div>
    <div class="card-body">
      <div class="table-responsive-horizontal">
        <b-table
          id="cases-table"
          responsive
          :items="filtered_cases"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          class="full-width-table"
        >
          <template v-slot:cell(names)="data">
            <p
              class="btn-link mb-0 position-relative monitor-widget"
              @click="openSearch(data)"
            >
              {{ data.value }}
              <span class="badge badge-danger">{{ data.item.total_hits }}</span>
            </p>
          </template>

          <template v-slot:cell(checkbox)="data">
            <input
              type="checkbox"
              @change="caseChecked($event)"
              :value="data"
              v-model="selected_cases"
            />
          </template>
          <template v-slot:cell(monitor)="data" class="text-center">
            <div
              class="togglebutton other mt-md-3 form-label-group d-flex justify-content-center"
              v-tippy="{ arrow: true, theme: 'light-border', maxWidth: 180 }"
              :content="$t('message.comply_advantage.tippy')"
            >
              <label class="control-label">
                <input
                  type="checkbox"
                  @click="changeMonitoredState(data)"
                  v-model="data.value"
                />
                <span class="toggle"></span>
              </label>
            </div>
            <label style="padding-left: 60px; margin-top: -20px"></label>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      filter: {
        date_from: "",
        date_to: "",
        name: "",
        reference: "",
        match: [],
        risk: [],
        //ssigned_to: [],
        //searched_by: [],
        changed: [],
        monitored: false,
        matched_types: [],
      },
      selected_cases: [],
      loading: false,
      currentPage: 0,
      perPage: 10,
      cases: [],
      contrsearch_country_focus: false,
      filter_match_focused: false,
      filter_risk_focused: false,
      filter_searched_by_focused: false,
      filter_changed_focused: false,
      filter_monitored_focused: false,
      filter_matched_types_focused: false,

      filter_assigned_to_focused: false,
      countries: [],
      fields: [
        // {
        // 		key: 'monitor',
        // 		label: 'Вкл./выкл. монитор.',//this.$t('message.comply_advantage.filter_monitored'),
        // 		sortable: false,
        //         class: 'bg-success-light'
        // 	},
        {
          key: "created",
          label: this.$t("message.comply_advantage.table_created"),
          sortable: false,
        },
        {
          key: "names",
          label: this.$t("message.comply_advantage.table_names"),
          sortable: false,
        },
        {
          key: "ref",
          label: this.$t("message.comply_advantage.table_ref"),
          sortable: false,
        },
        {
          key: "match_status",
          label: this.$t("message.comply_advantage.table_match_status"),
          sortable: false,
        },

        {
          key: "risk_level",
          label: this.$t("message.comply_advantage.table_risk_level"),
          sortable: false,
        },
        {
          key: "changed",
          label: this.$t("message.comply_advantage.table_changed"),
          sortable: false,
        },
      ],
      changed_types: [
        {
          display_text: this.$t("message.comply_advantage.filter_changed_all"),
          value: 0,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_changed_changed",
          ),
          value: 1,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_changed_unchanged",
          ),
          value: 2,
        },
      ],
      monitored_types: [
        {
          display_text: this.$t(
            "message.comply_advantage.filter_monitored_all",
          ),
          value: 0,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_monitored_actively",
          ),
          value: 1,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_monitored_suspended",
          ),
          value: 2,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_monitored_unmonitored",
          ),
          value: 3,
        },
      ],
      matched_types_types: [
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_all",
          ),
          value: 0,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_sanctions",
          ),
          value: 1,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_warnings",
          ),
          value: 2,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_fitness_probity",
          ),
          value: 3,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_peps_all",
          ),
          value: 4,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_pep_1",
          ),
          value: 5,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_pep_2",
          ),
          value: 6,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_pep_3",
          ),
          value: 7,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_pep_4",
          ),
          value: 8,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_adverse_media",
          ),
          value: 9,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_financial_crime",
          ),
          value: 10,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_violent_crime",
          ),
          value: 11,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_sexual_crime",
          ),
          value: 12,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_terrorism",
          ),
          value: 13,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_fraud",
          ),
          value: 14,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_narcotics",
          ),
          value: 15,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_matched_types_other",
          ),
          value: 16,
        },
      ],
      searched_by_types: [{ display_text: "Test type", value: 0 }],
      risk_types: [
        {
          display_text: this.$t("message.comply_advantage.filter_risk_all"),
          value: 0,
        },
        {
          display_text: this.$t("message.comply_advantage.filter_risk_unknown"),
          value: 1,
        },
        {
          display_text: this.$t("message.comply_advantage.filter_risk_low"),
          value: 2,
        },
        {
          display_text: this.$t("message.comply_advantage.filter_risk_medium"),
          value: 3,
        },
        {
          display_text: this.$t("message.comply_advantage.filter_risk_high"),
          value: 4,
        },
      ],
      assigned_to_types: [{ display_text: "Test type", value: 0 }],
      match_types: [
        {
          display_text: this.$t("message.comply_advantage.filter_match_all"),
          value: 0,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_match_unknown",
          ),
          value: 1,
        },
        {
          display_text: this.$t("message.comply_advantage.filter_match_no"),
          value: 2,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_match_potential",
          ),
          value: 3,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_match_false_positive",
          ),
          value: 4,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_match_true_positive",
          ),
          value: 5,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_match_true_positive_approve",
          ),
          value: 6,
        },
        {
          display_text: this.$t(
            "message.comply_advantage.filter_match_true_positive_reject",
          ),
          value: 7,
        },
      ],
    };
  },
  mounted() {
    this.searchManagement(null);
  },
  computed: {
    filtered_cases() {
      return this.cases.slice(0, 3);
    },
  },
  methods: {
    openSearch(data) {
      this.$router.push({
        name: "ca-single",
        params: {
          data,
        },
      });
    },
    searchManagement(filter) {
      this.cases = [];
      var url = window.base + "/document/GetAMLSearches";
      if (window.location.hostname == "attistrade.ru")
        url =
          "https://attistrade.kz/api/ca_searches?api_key=6e545cff-15ff-4918-9242-f4544653c5ff&api_secret=6911da045dcb36c7ed0e270dc7bed3b670bc1a49149277b29ac02ffc52f6a809";
      if (window.location.hostname == "attistrade.cn")
        url =
          "https://attistrade.kz/api/ca_searches?api_key=c507c645-adaa-42e6-9e80-c4d088452827&api_secret=6911da045dcb36c7ed0e270dc7bed3b670bc1a49149277b29ac02ffc52f6a809";
      axios.post(url, this.filter).then((response) => {
        response.data.forEach((item) => {
          var tmp = {};
          tmp.created = item.created_at;
          tmp.names = item.search_term;
          tmp.ref = item.ref;
          tmp.match_status = item.match_status;
          tmp.risk_level = item.risk_level;
          tmp.total_hits = item.total_hits;
          //tmp.assigned_to = "Sergey Nikolayev";
          //tmp.searcher = "Sergey";
          if (typeof item.monitors[0] !== "undefined") {
            tmp.changed = item.monitors[0].updated_at;
          }

          tmp.monitor = item.monitor;
          tmp.id = item.id;
          this.cases.push(tmp);
        });
      });
    },
  },
};
</script>
<style scoped>
.monitor-widget span {
  position: absolute;
  display: block;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

/* Mobile table responsive styles */
.table-responsive-horizontal {
  width: 100%; 
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Ensure table takes full width on mobile */
@media (max-width: 767.98px) {
  .full-width-table {
    width: 100%;
    min-width: 650px; /* Ensure minimum width for all columns to be visible */
    table-layout: fixed;
  }
  
  /* Keep cells from wrapping text */
  .full-width-table td, 
  .full-width-table th {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
<style>
.table thead th {
  border: 0;
}
.dash table thead tr th:first-child,
.dash table tr > td:first-child {
  width: 205px;
}

/* Additional mobile styles */
@media (max-width: 767.98px) {
  /* Add indicator for horizontal scroll */
  .table-responsive-horizontal:after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 5px;
    background: linear-gradient(to right, rgba(0,0,0,0), rgba(0,0,0,0.1));
    pointer-events: none;
  }
  
  /* Set specific column widths for mobile */
  .dash table tr > td.created,
  .dash table thead tr th.created {
    min-width: 120px;
  }
  
  .dash table tr > td.names,
  .dash table thead tr th.names {
    min-width: 150px;
  }
  
  .dash table tr > td.ref,
  .dash table thead tr th.ref {
    min-width: 130px;
  }
  
  .dash table tr > td.match_status,
  .dash table thead tr th.match_status {
    min-width: 110px;
  }
  
  .dash table tr > td.risk_level,
  .dash table thead tr th.risk_level {
    min-width: 100px;
  }
  
  .dash table tr > td.changed,
  .dash table thead tr th.changed {
    min-width: 120px;
  }
}
</style>